<div class="g-modal-v2 update-phone-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'update_phone_modal.title' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <form
    class="g-modal-v2-content"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    @if (state() === 'input') {
      <div class="g-form-control">
        <label
          class="g-form-label"
          for="phone-number"
        >
          {{ 'update_phone_modal.enter_new_phone_number' | translate }}
        </label>

        <input
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid(form.controls.phoneNumber)"
          [formControl]="form.controls.phoneNumber"
          [mask]="PHONE_NUMBER_MASK"
          type="text"
          inputmode="tel"
          id="phone-number"
          [placeholder]="'380123456789' | mask:PHONE_NUMBER_MASK"
          appAutofocus
        >

        @if (isControlInvalid(form.controls.phoneNumber)) {
          <div class="g-form-control-error">
            {{ 'global.required_field' | translate }}
          </div>
        }
      </div>

      @if (error()) {
        <div class="g-form-error">
          {{ error() }}
        </div>
      }
    } @else if (state() === 'otp') {
      <tc-otp
        [otpRequest]="otpRequest()"
        [otpDigitsFormArray]="form.controls.otpDigits"
        [isLoading]="isLoading()"
        [error]="error()"
        (submitted)="onSubmit()"
        (resendOtp)="updatePhoneNumberInit()"
      />

      <button
        class="g-main-link go-back"
        [disabled]="isLoading()"
        (click)="goBackFromOtp()"
        type="button"
      >
        {{ 'global.back' | translate }}
      </button>
    } @else if (state() === 'conflict') {
      <tc-merge-accounts
        [identifier]="conflictPhoneNumber()"
        [conflictMessage]="conflictMessage()"
        (merged)="onMerged()"
        (cancelled)="onMergeCancelled()"
      />
    } @else {
      <div class="success-header">
        @if (updateInitResponseMessage()) {
          {{ 'update_phone_modal.success_text' | translate }}
        } @else {
          {{ 'update_phone_modal.success_header' | translate }}
        }
      </div>
      <div
        class="success-text g-html-description"
        [class.warning]="updateInitResponseMessage()"
      >
        @if (isMerged()) {
          {{ 'merge_accounts.success_text' | translate }}
        } @else {
          {{ updateInitResponseMessage() || ('update_phone_modal.success_text' | translate) }}
        }
      </div>
    }

    @if (state() !== 'otp' && state() !== 'conflict') {
      <tc-button
        class="update-phone-modal-submit"
        [isLoading]="isLoading()"
        [isDisabled]="isSubmitDisabled()"
        buttonType="submit"
        buttonSize="large"
      >
        @if (state() === 'input') {
          {{ 'global.confirm' | translate }}
        } @else {
          {{ 'global.done' | translate }}
        }
      </tc-button>
    }
  </form>
</div>
